import { PixiBrush, createPixiBrush, currentBrush, DEGREES, RADIANS } from "./brush.js";

export { PixiBrush, createPixiBrush, DEGREES, RADIANS };

const call = name => (...args) => currentBrush()[name](...args);

export const load = brush => (brush ?? currentBrush()).activate();

export const instance = load;

export const render = call("render"), clear = call("clear");

export const seed = call("seed"), noiseSeed = call("noiseSeed"), random = call("random"), noise = call("noise"), wRand = call("wRand");

export const angleMode = call("angleMode"), getAngleMode = call("getAngleMode"), push = call("push"), pop = call("pop"), translate = call("translate"), rotate = call("rotate"), scale = call("scale");

export const add = call("add"), box = call("box"), getBrushParams = call("getBrushParams"), scaleBrushes = call("scaleBrushes"), pick = call("pick"), stroke = call("stroke"), strokeWeight = call("strokeWeight"), set = call("set"), noStroke = call("noStroke"), clip = call("clip"), noClip = call("noClip"), line = call("line"), flowLine = call("flowLine");

export const fill = call("fill"), noFill = call("noFill"), fillBleed = call("fillBleed"), fillTexture = call("fillTexture"), wash = call("wash"), noWash = call("noWash");

export const hatch = call("hatch"), hatchStyle = call("hatchStyle"), noHatch = call("noHatch"), hatchArray = call("hatchArray"), mass = call("mass"), noMass = call("noMass"), massArray = call("massArray");

export const rect = call("rect"), circle = call("circle"), arc = call("arc"), polygon = call("polygon"), spline = call("spline"), beginShape = call("beginShape"), vertex = call("vertex"), endShape = call("endShape"), beginStroke = call("beginStroke"), move = call("move"), endStroke = call("endStroke");

export const field = call("field"), noField = call("noField"), addField = call("addField"), refreshField = call("refreshField"), listFields = call("listFields"), wiggle = call("wiggle");

export class Polygon {
  constructor(...args) {
    return new (currentBrush().Polygon)(...args);
  }
}

export class Plot {
  constructor(...args) {
    return new (currentBrush().Plot)(...args);
  }
}

export class Position {
  constructor(...args) {
    return new (currentBrush().Position)(...args);
  }
}
